import { render } from "./Primary1.vue?vue&type=template&id=3b5ed4f0&ts=true"
import script from "./Primary1.vue?vue&type=script&lang=ts"
export * from "./Primary1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Primary1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b5ed4f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b5ed4f0', __exports__)) {
    api.reload('3b5ed4f0', __exports__)
  }
  
  module.hot.accept("./Primary1.vue?vue&type=template&id=3b5ed4f0&ts=true", () => {
    api.rerender('3b5ed4f0', render)
  })

}


export default __exports__